import { RMAXLogger } from './LoggerService/RMAXLogger';
import Events from '../utilities/EventEmitter';
import { MEMORY_CHECK_INTERVAL_MS } from '../workers/constants';
import * as Comlink from 'comlink';

class MemoryLogger {
  constructor() {
    this.initializeWorker();
    this.enableHighMemoryUsageWarning = false;
  }

  async initializeWorker() {
    const MemoryWorker = new Worker(
      /* webpackChunkName: "memory-worker" */ new URL('./../workers/memory.worker.js', import.meta.url)
    );

    this.workerInstance = Comlink.wrap(MemoryWorker);
  }

  getCurrentMemoryUsage = Comlink.proxy(() => {
    return {
      usedJSHeapSize: performance.memory.usedJSHeapSize,
      totalJSHeapSize: performance.memory.totalJSHeapSize,
      jsHeapSizeLimit: performance.memory.jsHeapSizeLimit
    };
  });

  logMemoryUsageAndTriggerWarning = Comlink.proxy((message, shouldShowWarning) => {
    message && RMAXLogger.info(message);
    this.enableHighMemoryUsageWarning && shouldShowWarning && Events.emit('onMemoryUsageExceeded');
  });

  setHighMemoryUsageWarningFeatureFlag = (isEnabled) => {
    this.enableHighMemoryUsageWarning = isEnabled;
  }

  // Start monitoring memory usage
  async startMonitoringMemory() {
    await this.workerInstance.startMonitoringMemory(
      MEMORY_CHECK_INTERVAL_MS,
      this.getCurrentMemoryUsage,
      this.logMemoryUsageAndTriggerWarning
    );
  }

  // Stop monitoring memory usage, manual resource cleanup
  async stopMonitoringMemory() {
    await this.workerInstance.stopMonitoringMemory();
  }
}

const memoryLoggerInstance =
  typeof performance !== 'undefined' && performance?.memory ? new MemoryLogger() : null;
export default memoryLoggerInstance;
